import { query } from '$app/server';
import { getRequestEvent } from '$app/server';
import type { PremiumResponse } from '~/types';

export const getPremium = query(async (): Promise<PremiumResponse> => {
  const { locals } = getRequestEvent();

  if (!locals.user) {
    return { premium: false };
  }

  const { supabase } = locals;

  const [sub, invoice] = await Promise.all([
    supabase
      .from('subscriptions')
      .select('status, stripe_payload')
      .order('created_at', { ascending: false })
      .limit(1)
      .single(),
    supabase
      .from('invoices')
      .select('status, created_at')
      .order('created_at', { ascending: false })
      .limit(1)
      .single(),
  ]);

  if (sub.data) {
    return {
      premium: ['active', 'trialing'].includes(sub.data.stripe_payload.status),
      subscription: true,
      created_at: invoice.data?.created_at,
      invoice_status: invoice.data?.status,
      subscription_status: sub.data.stripe_payload.status,
    };
  }

  const paid = await supabase
    .from('payments')
    .select('provider')
    .order('created_at', { ascending: false })
    .limit(1)
    .single();

  if (paid.error) {
    return { premium: false };
  }

  return { premium: !!paid.data.provider };
});
